import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';

export const modalStyles = css`
  background-color: ${token(
    'color.background.accent.blue.subtlest',
    '#091E42'
  )};
  padding: 32px 24px;
  position: relative;

  h2 {
    font-weight: 600;
  }
`;

export const closeModalButtonStyles = css`
  position: absolute;
  top: 16px;
  right: 16px;
  height: 24px;
  width: 24px;
`;

export const imageStyles = css`
  margin-bottom: 24px;
  text-align: center;
`;

export const descriptionStyles = css`
  font-size: 16px;
  line-height: 1.5;
  margin-top: 12px;
  margin-bottom: 32px;
`;

export const ctaButtonStyles = css`
  font-size: 14px;
`;
